
import React from 'react';
import { connect } from 'react-redux';
import {DashboardContainer, Info, TextLoading} from "../../../funcs/utils";
import { Text } from "../../../../lib/prm/text";
import { Name } from "../../../../lib/prm/name";
import {FlowRender} from "../../../../lib/flow-render";
import { Action } from "../../../funcs/utils";
import { ExecutePaymentDialog2 } from "../../../payment/execute-payment-2";
import {deep_copy} from "../../../../lib/js-utils";
import { InfoDialog } from "../../../helper/modals";
import {UserAcctType} from "../../../../lib/dwolla/constants";
import {sprintf} from "sprintf-js";
import {TWO_FACTOR_AUTH} from "../../../../lib/constants";

const CONTRIB_AMT = new Text(new Name("CONTRIB_AMT"));

const ALL_PRMS = new FlowRender(0, [
  CONTRIB_AMT
]);

const MakePaymentCard_ = props => {

  const name = props.user.invite.trustee_name;
  const component = props.component;
  const bold_style = {
    fontWeight: "bold",
  }
  const info_text = "Up to $15,000 per year ($30,000 per married couple) can be "
    + `gifted to ${name} without triggering any gift taxes. However, these `
    + "contributions will not be tax deductable to you.";
  const input_style = {
    width: "10rem",
    textAlign: "center",
  }

  const on_payment_cb = () => {
    component.setState({ show_payment_popup: true });
  };

  const on_done = (result, is_error) => {
    if (is_error) {
      component.setState({
        payment_error: true,
        execute_payment: false,
      });
      return;
    }
    component.payment_callback.startCallback();
    const state = deep_copy(component.state);
    CONTRIB_AMT.setValue(state, "");
    component.setState(state);
  }

  const text = "Now that we've verified your bank account, how much would you "
    + "like to contribute to ";
  const popup_style = {
    right: "0",
    width: "30rem",
  }

  const payment_from = {
    username: TWO_FACTOR_AUTH ? component.props.user.username : component.props.user.id,
    acct: UserAcctType.EXTERNAL,
  }
  const payment_to = {
    username: props.user.invite.username,
    acct: sprintf("%04d", props.user.invite.index),
  }

  const error_dialog = component.state.payment_error
    ? (
      <InfoDialog
        onClick={() => () => component.setState({ payment_error: false })}>
        <div>Error sending payment.</div>
        <div>Try again later.</div>
      </InfoDialog>
    )
    : null;

  return (
    <DashboardContainer
      spinner={component.state.execute_payment}
      client={props.client}
      title={"Ready to make a contribution"}>
      <div>
        <span>{text}</span>
        <span style={bold_style}>{name}</span>
        <span>'s UGMA Trust Account?</span>
        <Info
          id={"payment_info"}
          component={component}
          popup_style={popup_style}
          text={info_text}/>
      </div>
      <div style={{marginTop: "1rem"}}>
        {CONTRIB_AMT.renderInput(component, input_style) }
        <span> Dollars</span>
      </div>
      <div align={"center"}>
        <Action onClick={on_payment_cb}>
          <TextLoading
            label={"Contribute"}
            loading={component.state.execute_payment}/>
        </Action>
      </div>
      <ExecutePaymentDialog2
        state={component.state}
        component={component}
        payment_from={payment_from}
        payment_to={payment_to}
        contrib_prm={CONTRIB_AMT}
        on_payment_done={on_done}/>
      { error_dialog }
    </DashboardContainer>
  )
}

const mapDispatchToProps = dispatch => {
  return {
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    dwolla: state.dwolla,
    user: state.user,
  };
}

const init_make_payment = (component) => {
  const invite = component.props.user.invite;

  const state = {};
  if (invite) {
    ALL_PRMS.init(state, invite.prms);
  }
  state.payment_error = false;
  return state;
}

const MakePaymentCard = connect(mapStateToProps, mapDispatchToProps)(MakePaymentCard_);

export { MakePaymentCard, init_make_payment };

